import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import '../../assets/css/App.css';
import { max } from 'moment';
import Header1 from '../public';

const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;

class LDIntroChi extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
                <div>
                  <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
              <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['1']}
                    defaultOpenKeys={['sub3']}
                    style={{ height: '100%' }}
                  >
                    <SubMenu key="sub3" title={<span><Icon type="user" />碘油沉积</span>}>
                      <Menu.Item key="1"><Link to="/hcc-ld-introduction-chi">功能介绍</Link></Menu.Item>
                      <Menu.Item key="2"><Link to="/hcc-ld-evaluation-chi">碘油分析</Link></Menu.Item>
                    </SubMenu>
                    <SubMenu key="sub4" title={<span><Icon type="user" />预后预测</span>}>
                      <Menu.Item key="5"><Link to="/hcc-cal-introduction-chi">功能介绍</Link></Menu.Item>
                      <Menu.Item key="6"><Link to="/hcc-cal-calculation-chi">预后分析</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                <div>
                            <Content style={{ marginLeft: 50, background: '#dcefef' }}>
                                <div style={{ marginLeft: 100, paddingTop:30, width: 600, height: 1000, background: '#dcefef' }}>
                                <txt style={{fontSize:20,marginTop:50,}}>
                                <txt style={{fontSize:22,fontWeight:'bold'}}>欢迎访问肝细胞癌患者行TACE手术后碘油沉积（LD）定量化分析模块。</txt> 
                                <br/><br/>基于TACE后一个月的影像学检查的碘油沉积是临床最常用的TACE疗效评估生物标志物，该指标作为目标肿瘤区域栓塞的主要参考，为后续治疗方案制定提供依据。 既往研究已经证实，其准确的定量评估为随后的治疗决策和随访计划的制定具有重要意义。 然而，目前TACE术后的碘油沉积分类方法多为单变量算法，例如沉积形态，沉积比率，沉积模式和癌区坏死等，且每种方法仅考虑碘油沉积的某一个方面。 因此，在TACE后一个月对碘油沉积的全方位定量化评估对于未来更加精确临床治疗决策是非常必要的。
                                <br/><br/>针对这一临床问题，我们对肝细胞癌患者TACE术后一个月的碘油沉积分类方法进行了系统性回顾分析。 通过确定每种分类方法的优点并审查所报道的每个子类别的生存预后数据，我们提出了一个更为精确的TACE术后碘油沉积评价策略。 将碘油沉积百分比，沉积模式，沉积分布和肿瘤坏死等因素作为构建新的分析指标的独立变量，将所有四个因素对生存的协同作用定量整合到碘油沉积新生物标志物分层分析的指数模型中。
                                
                                </txt>
                                </div>
                            </Content>
                        </div>

                        <div>
                            <Content style={{ background: '#dcefef' }}>
                                <div style={{ marginLeft: 120, paddingTop:30,paddingRight:100, width: 700, height: 1000, background: '#dcefef' }}>
                                
                                <txt style={{fontSize:28,fontWeight:'bold',}}>
                                使用介绍
                                </txt>
                        
                                <txt style={{fontSize:20}}>
                                <br/><br/>点击左侧导航页的 <txt style={{fontSize:22,fontWeight:'bold'}}>碘油分析</txt> 按钮, 输入患者术后一个月时的各项碘油沉积参数。 本算法将依据输入数据预测该患者的中位进展时间概率，以及接受TACE手术的肝细胞癌患者的累积1年，2年和3年无进展率。
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;y=e^(-Dr×Cp×Nc×Up×b)</txt>

                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>Dr</txt> 表示碘油沉积比率(分为以下四个亚组：100％，85％-99％，35％-85％，以及 &#60;35%)。
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>Cp</txt> 表示碘油沉积致密与否。 
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>Nc</txt> 表示癌区坏死比率 (100％，50％-99％，以及 &#60;50%)。
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>Up</txt> 表示碘油沉积分布 (结节摄取模式[NU]，弥漫性模式中的多结节碘油摄取模式[MNU]，以及其他)。
                                <br/><br/><txt style={{fontSize:22,fontWeight:'bold'}}>b</txt> 为保留变量，以便于在未来的研究中增加新的风险因素。
                                    </txt>
   
                                </div>
                            </Content>
                        </div>
              </Layout>
            </Content>
            </div>
        )
    }
}
export default LDIntroChi;